var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "checkout-login details-container",
      class: {
        "details-containerTs":
          _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
      },
    },
    [
      _c(
        "h3",
        {
          staticClass: "details-container__header",
          class: {
            "details-container__headerTs":
              _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
          },
        },
        [_vm._v(_vm._s(_vm.data.login.title))]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "details-container__body" },
        [
          _c("div", {
            staticClass: "details-container__body-intro",
            domProps: { innerHTML: _vm._s(_vm.data.login.descriptionHtml) },
          }),
          _vm._v(" "),
          _vm.isLoginForm
            ? _c("Login", {
                attrs: { data: _vm.data.login },
                on: { loginSuccess: _vm.loginSuccess },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "d-flex justify-content-center flex-md-row":
                  _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
                "all-unset":
                  _vm.isLoginForm &&
                  _vm.data.brandNameFormatted == _vm.Brand.Travelsphere,
              },
            },
            [
              !_vm.isLoginForm
                ? _c(
                    "button",
                    {
                      staticClass: "btn",
                      class: {
                        "mr-lg-10":
                          _vm.data.brandNameFormatted ===
                          _vm.Brand.Travelsphere,
                      },
                      attrs: {
                        "aria-label": "Log in",
                        title: "Click to log in",
                      },
                      on: { click: _vm.login },
                    },
                    [_vm._v("Log in")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  class: {
                    "btn btn--outline-gray-color btn--outline-gray-color_sm js-modal resultCardMapTs":
                      !_vm.isLoginForm &&
                      _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
                    "link link-spacer":
                      _vm.data.brandNameFormatted !== _vm.Brand.Travelsphere ||
                      _vm.isLoginForm,
                  },
                  attrs: {
                    "aria-label": "Continue without log in",
                    title: "Continue without log in",
                  },
                  on: { click: _vm.skipLogin },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.data.brandNameFormatted === _vm.Brand.Travelsphere
                          ? "Continue"
                          : "Continue without log in"
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }